import { Button, Chip, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';
import { ExpandIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { LocationFilterMobile } from 'src/app/pages/search/shared/components';

import { ClearLocationFilter } from './components/ClearLocationFilter';
import { useLocationMobileButton } from './hooks/useLocationMobileButton';

export const LocationMobileButton: React.FC = () => {
	const {
		data: { disabled, active, selectedLocationFilterName },
	} = useLocationMobileButton();

	return (
		<div className="relative">
			<Modal
				onClose={() => {}}
				trigger={
					<Chip as="button" trailingIcon={<ExpandIcon />} active={active} size="small" disabled={disabled}>
						{selectedLocationFilterName}
					</Chip>
				}
			>
				<ModalHeader
					title={
						<Text variant="heading" size="small">
							<Translate value="corgi.search.filters.location.title" />
						</Text>
					}
				/>

				<ModalBody className="min-h-[50vh]">
					<LocationFilterMobile />
				</ModalBody>

				<ModalFooter>
					<Button variant="primary">
						<Translate value="corgi.search.filters.view_results" />
					</Button>
					<ClearLocationFilter />
				</ModalFooter>
			</Modal>
		</div>
	);
};
